// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__17Q8Y","header":"ClearentDisclaimer_header__yaMzn","inner":"ClearentDisclaimer_inner__3MNuR"};